/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Paragraph from "@tiptap/extension-paragraph";
import { className } from "./class-name";

const SimpliCityParagraph = Paragraph.extend({
    
    draggable: false,
    
    // this allows us to specify the attributes that we want to manage
    addAttributes () {
        return {
            // the parent may not exist: https://tiptap.dev/docs/editor/guide/custom-extensions#extend-existing-attributes
            ...this.parent?.(),
            class: className,
        };
    },
});

export { SimpliCityParagraph };
